/**
 * @file Public service — unauthenticated API calls for public-facing pages.
 *
 * Used by the public professional profile (/c/:slug), public booking flow,
 * and token-based appointment management (no login required).
 *
 * @module services/public
 */
import api from "./api";

/**
 * Public API methods (no authentication required unless noted).
 * @type {Object}
 */
export const publicService = {
  // Get a professional's full public profile by slug
  getProfile: (slug) => api.get(`/public/professionals/${slug}`),

  // Get available slots for a professional on a given date ("YYYY-MM-DD")
  getSlots: (slug, date, locationId) =>
    api.get(`/public/professionals/${slug}/slots`, {
      params: { date, ...(locationId ? { locationId } : {}) },
    }),

  // Book an appointment from the public profile (patient must be logged in with verified phone)
  bookAppointment: (data) => api.post("/public/appointments", data),

  // Get which dates in a range have at least one available slot
  getAvailableDates: (slug, from, to, locationId) =>
    api.get(`/public/professionals/${slug}/available-dates`, {
      params: { from, to, ...(locationId ? { locationId } : {}) },
    }),

  // Get appointment details by token (no auth — permanent patient link)
  getAppointmentByToken: (token) => api.get(`/public/cita/${token}`),

  // Confirm attendance by token — AGENDADA → CONFIRMADA (only within 48h)
  confirmAttendanceByToken: (token) => api.patch(`/public/cita/${token}/confirm-attendance`),

  // Cancel appointment by token (no auth)
  cancelByToken: (token, cancelReason) =>
    api.patch(`/public/cita/${token}/cancel`, { cancelReason }),

  // Track booking intent on a maxed-out professional profile (fire-and-forget)
  trackBookingIntent: (professionalId) =>
    api.post(`/public/booking-intent/${professionalId}`).catch(() => {}),
};
